<table class="w-full" mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="name">
    <th *matHeaderCellDef mat-header-cell>Name</th>
    <td *matCellDef="let terminal" mat-cell>
      {{ terminal.name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="merchantId">
    <th *matHeaderCellDef mat-header-cell>Merchant Id</th>
    <td *matCellDef="let terminal" mat-cell>
      {{ terminal.merchantId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="terminalId">
    <th *matHeaderCellDef mat-header-cell>Terminal Id</th>
    <td *matCellDef="let terminal" mat-cell>
      {{ terminal.terminalId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="practitioner">
    <th *matHeaderCellDef mat-header-cell>Associated Practitioner</th>
    <td *matCellDef="let terminal" mat-cell>
      @if (terminal.practitionerRef) {
        <pr-staffer-display
          *ngIf="
            terminal.practitionerRef
              | map: globalStore.getStaffer$ : globalStore
              | async as staffer
          "
          [staffer]="staffer"
        />
      } @else {
        <span class="mat-caption opacity-50">No Practitioner Associated</span>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="bridgeDevice">
    <th *matHeaderCellDef mat-header-cell class="w-28">Bridge Device</th>
    <td *matCellDef="let terminal" mat-cell class="w-28">
      {{ terminal | map: bridgeDeviceName$ | async }}
    </td>
  </ng-container>

  <ng-container matColumnDef="lastActive">
    <th *matHeaderCellDef mat-header-cell class="w-28">Last Synced</th>
    <td *matCellDef="let terminal" mat-cell class="w-28">
      {{ terminal.lastActive | moment | amDateFormat: dateFormat }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th *matHeaderCellDef mat-header-cell>
      <button
        *ngIf="practice$ | async as practice"
        class="w-full"
        mat-flat-button
        color="primary"
        (click)="hicapsConnect.syncTerminalsForDevice(practice)"
      >
        Sync Terminals
      </button>
    </th>
    <td *matCellDef="let terminal" mat-cell class="!text-right">
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <ng-template matMenuContent>
          <button mat-menu-item (click)="hicapsConnect.editTerminal(terminal)">
            <mat-icon color="accent">edit</mat-icon> Edit
          </button>
          <button
            mat-menu-item
            (click)="hicapsConnect.deleteTerminal(terminal)"
          >
            <mat-icon color="warn">delete</mat-icon> Delete
          </button>

          <button mat-menu-item (click)="hicapsConnect.testTerminal(terminal)">
            <mat-icon color="accent">sync</mat-icon> Test Terminal
          </button>
          <button mat-menu-item (click)="hicapsConnect.viewLogs(terminal)">
            <mat-icon color="accent">receipt_long</mat-icon> View Logs
          </button>
        </ng-template>
      </mat-menu>
    </td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns()" mat-header-row></tr>
  <tr *matRowDef="let row; columns: displayedColumns()" mat-row></tr>
</table>
